// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CalendarIcon,
  CheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  CopyIcon,
  DollarSignIcon,
  FunnelIcon,
  PercentIcon,
  PlusIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SquarePenIcon,
  TicketIcon,
  Trash2Icon,
  TriangleAlertIcon,
  jsxRuntime,
  motion,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const CouponsPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState(true),
    [a, l] = React.useState(null),
    [c, d] = React.useState(""),
    [f, h] = React.useState("all"),
    [p, g] = React.useState("all"),
    [y, v] = React.useState(false),
    [j, N] = React.useState(false),
    [b, S] = React.useState(false),
    [O, _] = React.useState(null),
    [C, A] = React.useState(false),
    [T, M] = React.useState(1),
    [k] = React.useState(10),
    [$, I] = React.useState({
      code: "",
      description: "",
      category: "both",
      discount_type: "percent",
      discount_value: "",
      max_discount: "",
      usage_limit: "",
      expiry_date: "",
      active: true,
    }),
    U = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    },
    q = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    z = async () => {
      try {
        r(true);
        const V = await api.get("/coupons/active");
        (t(V.data || []), l(null));
      } catch (V) {
        (console.error("Error fetching coupons:", V),
          l("Failed to load coupons. Please try again."),
          t([]));
      } finally {
        r(false);
      }
    };
  React.useEffect(() => {
    z();
  }, []);
  const Y = e.filter((V) => {
      const de =
          V.code.toLowerCase().includes(c.toLowerCase()) ||
          V.description.toLowerCase().includes(c.toLowerCase()),
        oe =
          f === "all" ||
          (f === "active" &&
            V.active &&
            (!V.expiry_date || new Date(V.expiry_date) >= new Date())) ||
          (f === "expired" && V.expiry_date && new Date(V.expiry_date) < new Date()) ||
          (f === "inactive" && !V.active),
        ce = p === "all" || V.category === p;
      return de && oe && ce;
    }),
    F = Math.ceil(Y.length / k),
    B = (T - 1) * k,
    K = B + k,
    Q = Y.slice(B, K),
    ne = () => {
      I({
        code: "",
        description: "",
        category: "both",
        discount_type: "percent",
        discount_value: "",
        max_discount: "",
        usage_limit: "",
        expiry_date: "",
        active: true,
      });
    },
    L = async (V) => {
      var de, oe;
      V.preventDefault();
      try {
        A(true);
        const ce = {
          ...$,
          discount_value: parseFloat($.discount_value),
          max_discount: $.max_discount ? parseFloat($.max_discount) : null,
          usage_limit: $.usage_limit ? parseInt($.usage_limit) : 0,
          expiry_date: $.expiry_date || null,
        };
        (await api.post("/coupons/create", ce),
          v(false),
          ne(),
          z(),
          alert("Coupon created successfully!"));
      } catch (ce) {
        (console.error("Error creating coupon:", ce),
          alert(
            ((oe = (de = ce.response) == null ? undefined : de.data) == null
              ? undefined
              : oe.error) || "Failed to create coupon",
          ));
      } finally {
        A(false);
      }
    },
    ee = async (V) => {
      var de, oe;
      V.preventDefault();
      try {
        A(true);
        const ce = {
          ...$,
          discount_value: parseFloat($.discount_value),
          max_discount: $.max_discount ? parseFloat($.max_discount) : null,
          usage_limit: $.usage_limit ? parseInt($.usage_limit) : 0,
          expiry_date: $.expiry_date || null,
        };
        (await api.put(`/coupons/update/${O.id}`, ce),
          N(false),
          _(null),
          ne(),
          z(),
          alert("Coupon updated successfully!"));
      } catch (ce) {
        (console.error("Error updating coupon:", ce),
          alert(
            ((oe = (de = ce.response) == null ? undefined : de.data) == null
              ? undefined
              : oe.error) || "Failed to update coupon",
          ));
      } finally {
        A(false);
      }
    },
    re = async () => {
      var V, de;
      try {
        (A(true),
          await api.delete(`/coupons/delete/${O.id}`),
          S(false),
          _(null),
          z(),
          alert("Coupon deleted successfully!"));
      } catch (oe) {
        (console.error("Error deleting coupon:", oe),
          alert(
            ((de = (V = oe.response) == null ? undefined : V.data) == null
              ? undefined
              : de.error) || "Failed to delete coupon",
          ));
      } finally {
        A(false);
      }
    },
    R = (V) => {
      (_(V),
        I({
          code: V.code,
          description: V.description || "",
          category: V.category,
          discount_type: V.discount_type,
          discount_value: V.discount_value.toString(),
          max_discount: V.max_discount ? V.max_discount.toString() : "",
          usage_limit: V.usage_limit ? V.usage_limit.toString() : "",
          expiry_date: V.expiry_date ? new Date(V.expiry_date).toISOString().split("T")[0] : "",
          active: V.active,
        }),
        N(true));
    },
    W = (V) => {
      (navigator.clipboard.writeText(V), alert("Coupon code copied to clipboard!"));
    },
    xe = (V) =>
      V.active
        ? V.expiry_date && new Date(V.expiry_date) < new Date()
          ? {
              status: "expired",
              color: "red",
            }
          : V.usage_limit > 0 && V.times_used >= V.usage_limit
            ? {
                status: "limit_reached",
                color: "orange",
              }
            : {
                status: "active",
                color: "green",
              }
        : {
            status: "inactive",
            color: "gray",
          },
    ve = (V) => {
      M(V);
    },
    te = () => {
      T > 1 && M(T - 1);
    },
    ye = () => {
      T < F && M(T + 1);
    };
  return n ? (
    <div
      className={
        "admin-page flex items-center justify-center bg-gradient-to-br from-purple-50 to-purple-100"
      }
    >
      <div className={"p-8 flex flex-col items-center"}>
        <div className={"w-16 h-16 relative"}>
          <div
            className={
              "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
            }
          />
          <div
            className={
              "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
            }
          />
        </div>
        <p className={"mt-4 text-gray-600"}>{"Loading coupons..."}</p>
      </div>
    </div>
  ) : a ? (
    <div
      className={
        "admin-page flex items-center justify-center bg-gradient-to-br from-purple-50 to-purple-100"
      }
    >
      <motion.div
        initial={{
          opacity: 0,
          scale: 0.95,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        className={"bg-white p-8 rounded-2xl shadow-xl max-w-md w-full"}
      >
        <div className={"text-center mb-6"}>
          <div
            className={
              "w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4"
            }
          >
            <TriangleAlertIcon className={"h-10 w-10 text-red-500"} />
          </div>
          <h2 className={"text-2xl font-bold text-gray-800 mb-2"}>{"Something went wrong"}</h2>
          <p className={"text-gray-600 mb-6"}>{a}</p>
        </div>
        <button
          onClick={z}
          className={
            "w-full bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white py-3 px-4 rounded-xl font-medium transition duration-300 flex items-center justify-center"
          }
        >
          <RefreshCwIcon className={"w-5 h-5 mr-2"} />
          {"Try Again"}
        </button>
      </motion.div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 via-purple-100 to-purple-50"}>
      <main className="admin-main">
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={U}
          className={"mb-10 relative"}
        >
          
          
          <div className={"relative flex flex-col md:flex-row md:items-center md:justify-between"}>
            <div>
              <span
                className={
                  "inline-block py-1 px-3 mb-3 bg-purple-100 text-purple-800 rounded-full text-sm font-medium"
                }
              >
                {"Coupon Management"}
              </span>
              <h1 className={"text-3xl md:text-4xl font-bold text-gray-900 mb-2 flex items-center"}>
                <TicketIcon className={"w-8 h-8 mr-3 text-purple-600"} />
                {"Manage Coupons"}
              </h1>
              <p className={"text-gray-600"}>
                {"Create and manage discount coupons for your products."}
              </p>
            </div>
            <button
              onClick={() => {
                (ne(), v(true));
              }}
              className={
                "mt-4 md:mt-0 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white py-3 px-6 rounded-xl font-medium transition duration-300 flex items-center shadow-lg"
              }
            >
              <PlusIcon className={"w-5 h-5 mr-2"} />
              {"Create Coupon"}
            </button>
          </div>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={q}
          className={"grid grid-cols-1 md:grid-cols-4 gap-6 mb-8"}
        >
          <motion.div
            variants={U}
            className={"bg-white rounded-2xl shadow-lg p-6 border border-gray-100"}
          >
            <div className={"flex items-center"}>
              <div
                className={
                  "w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center text-purple-600 mr-4"
                }
              >
                <TicketIcon className={"w-6 h-6"} />
              </div>
              <div>
                <p className={"text-sm font-medium text-gray-500"}>{"Total Coupons"}</p>
                <div className={"text-2xl font-bold text-gray-800"}>{e.length}</div>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={U}
            className={"bg-white rounded-2xl shadow-lg p-6 border border-gray-100"}
          >
            <div className={"flex items-center"}>
              <div
                className={
                  "w-12 h-12 rounded-xl bg-green-100 flex items-center justify-center text-green-600 mr-4"
                }
              >
                <CheckIcon className={"w-6 h-6"} />
              </div>
              <div>
                <p className={"text-sm font-medium text-gray-500"}>{"Active Coupons"}</p>
                <div className={"text-2xl font-bold text-gray-800"}>
                  {
                    e.filter(
                      (V) => V.active && (!V.expiry_date || new Date(V.expiry_date) >= new Date()),
                    ).length
                  }
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={U}
            className={"bg-white rounded-2xl shadow-lg p-6 border border-gray-100"}
          >
            <div className={"flex items-center"}>
              <div
                className={
                  "w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center text-red-600 mr-4"
                }
              >
                <ClockIcon className={"w-6 h-6"} />
              </div>
              <div>
                <p className={"text-sm font-medium text-gray-500"}>{"Expired Coupons"}</p>
                <div className={"text-2xl font-bold text-gray-800"}>
                  {e.filter((V) => V.expiry_date && new Date(V.expiry_date) < new Date()).length}
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={U}
            className={"bg-white rounded-2xl shadow-lg p-6 border border-gray-100"}
          >
            <div className={"flex items-center"}>
              <div
                className={
                  "w-12 h-12 rounded-xl bg-purple-100 flex items-center justify-center text-purple-600 mr-4"
                }
              >
                <PercentIcon className={"w-6 h-6"} />
              </div>
              <div>
                <p className={"text-sm font-medium text-gray-500"}>{"Usage Count"}</p>
                <div className={"text-2xl font-bold text-gray-800"}>
                  {e.reduce((V, de) => V + (de.times_used || 0), 0)}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={U}
          className={"bg-white rounded-2xl shadow-lg p-6 mb-8 border border-gray-100"}
        >
          <div className={"flex flex-col md:flex-row gap-4"}>
            <div className={"flex-1 relative"}>
              <SearchIcon
                className={
                  "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                }
              />
              <input
                type={"text"}
                placeholder={"Search coupons by code or description..."}
                value={c}
                onChange={(V) => d(V.target.value)}
                className={
                  "w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                }
              />
            </div>
            <div className={"relative"}>
              <FunnelIcon
                className={
                  "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                }
              />
              <select
                value={f}
                onChange={(V) => h(V.target.value)}
                className={
                  "pl-10 pr-8 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white"
                }
              >
                <option value={"all"}>{"All Status"}</option>
                <option value={"active"}>{"Active"}</option>
                <option value={"expired"}>{"Expired"}</option>
                <option value={"inactive"}>{"Inactive"}</option>
              </select>
            </div>
            <div className={"relative"}>
              <select
                value={p}
                onChange={(V) => g(V.target.value)}
                className={
                  "px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white"
                }
              >
                <option value={"all"}>{"All Categories"}</option>
                <option value={"both"}>{"Both"}</option>
                <option value={"software"}>{"Software"}</option>
                <option value={"hardware"}>{"Hardware"}</option>
              </select>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={U}>
          <div className={"bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100"}>
            {Y.length > 0 ? (
              <jsxRuntime.Fragment>
                <div className={"px-6 py-4 border-b border-gray-200 bg-gray-50"}>
                  <div className={"flex justify-between items-center"}>
                    <div className={"text-sm text-gray-600"}>
                      {"Showing "}
                      {B + 1}
                      {"-"}
                      {Math.min(K, Y.length)}
                      {" of "}
                      {Y.length}
                      {" coupons"}
                    </div>
                    <div className={"text-sm text-gray-600"}>
                      {"Page "}
                      {T}
                      {" of "}
                      {F}
                    </div>
                  </div>
                </div>
                <div className={"overflow-x-auto"}>
                  <table className={"min-w-full divide-y divide-gray-200"}>
                    <thead>
                      <tr>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Code"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Discount"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Category"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Usage"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Expiry"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Status"}
                        </th>
                        <th
                          className={
                            "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                          }
                        >
                          {"Actions"}
                        </th>
                      </tr>
                    </thead>
                    <tbody className={"bg-white divide-y divide-gray-200"}>
                      {Q.map((V) => {
                        const de = xe(V);
                        return (
                          <tr key={V.id} className={"hover:bg-gray-50 transition duration-150"}>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <div className={"flex items-center"}>
                                <div className={"flex-shrink-0"}>
                                  <div
                                    className={
                                      "w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center"
                                    }
                                  >
                                    <TicketIcon className={"w-5 h-5 text-purple-600"} />
                                  </div>
                                </div>
                                <div className={"ml-4"}>
                                  <div className={"flex items-center"}>
                                    <div className={"text-sm font-medium text-gray-900"}>
                                      {V.code}
                                    </div>
                                    <button
                                      onClick={() => W(V.code)}
                                      className={
                                        "ml-2 text-gray-400 hover:text-gray-600 transition-colors"
                                      }
                                    >
                                      <CopyIcon className={"w-4 h-4"} />
                                    </button>
                                  </div>
                                  {V.description && (
                                    <div className={"text-sm text-gray-500 truncate max-w-xs"}>
                                      {V.description}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <div className={"flex items-center"}>
                                <div
                                  className={
                                    "w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3"
                                  }
                                >
                                  {V.discount_type === "percent" ? (
                                    <PercentIcon className={"w-4 h-4 text-green-600"} />
                                  ) : (
                                    <DollarSignIcon className={"w-4 h-4 text-green-600"} />
                                  )}
                                </div>
                                <div>
                                  <div className={"text-sm font-medium text-gray-900"}>
                                    {V.discount_type === "percent"
                                      ? `${V.discount_value}%`
                                      : `₹${V.discount_value}`}
                                  </div>
                                  {V.max_discount && V.discount_type === "percent" && (
                                    <div className={"text-xs text-gray-500"}>
                                      {"Max: ₹"}
                                      {V.max_discount}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <span
                                className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${V.category === "both" ? "bg-purple-100 text-purple-800" : V.category === "software" ? "bg-purple-200 text-purple-900" : "bg-amber-100 text-amber-800"}`}
                              >
                                {V.category === "both"
                                  ? "Both"
                                  : V.category === "software"
                                    ? "Software"
                                    : "Hardware"}
                              </span>
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <div className={"text-sm text-gray-900"}>
                                {V.times_used || 0}
                                {V.usage_limit > 0 && (
                                  <span className={"text-gray-500"}>
                                    {"/"}
                                    {V.usage_limit}
                                  </span>
                                )}
                              </div>
                              {V.usage_limit > 0 && (
                                <div className={"w-full bg-gray-200 rounded-full h-1.5 mt-1"}>
                                  <div
                                    className={"bg-purple-600 h-1.5 rounded-full"}
                                    style={{
                                      width: `${Math.min(100, ((V.times_used || 0) / V.usage_limit) * 100)}%`,
                                    }}
                                  />
                                </div>
                              )}
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <div className={"text-sm text-gray-900"}>
                                {V.expiry_date ? (
                                  <div className={"flex items-center"}>
                                    <CalendarIcon className={"w-4 h-4 mr-1 text-gray-400"} />
                                    {new Date(V.expiry_date).toLocaleDateString()}
                                  </div>
                                ) : (
                                  <span className={"text-gray-500"}>{"No expiry"}</span>
                                )}
                              </div>
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <span
                                className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${de.color === "green" ? "bg-green-100 text-green-800" : de.color === "red" ? "bg-red-100 text-red-800" : de.color === "orange" ? "bg-orange-100 text-orange-800" : "bg-gray-100 text-gray-800"}`}
                              >
                                {de.status === "active"
                                  ? "Active"
                                  : de.status === "expired"
                                    ? "Expired"
                                    : de.status === "limit_reached"
                                      ? "Limit Reached"
                                      : "Inactive"}
                              </span>
                            </td>
                            <td className={"px-6 py-4 whitespace-nowrap"}>
                              <div className={"flex items-center space-x-3"}>
                                <button
                                  onClick={() => R(V)}
                                  className={
                                    "text-purple-600 hover:text-purple-900 transition-colors"
                                  }
                                  title={"Edit coupon"}
                                >
                                  <SquarePenIcon className={"w-4 h-4"} />
                                </button>
                                <button
                                  onClick={() => {
                                    (_(V), S(true));
                                  }}
                                  className={"text-red-600 hover:text-red-900 transition-colors"}
                                  title={"Delete coupon"}
                                >
                                  <Trash2Icon className={"w-4 h-4"} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {F > 1 && (
                  <div className={"bg-white px-4 py-3 border-t border-gray-200"}>
                    <div className={"flex items-center justify-between"}>
                      <div className={"flex-1 flex justify-between sm:hidden"}>
                        <button
                          onClick={te}
                          disabled={T === 1}
                          className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${T === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                        >
                          {"Previous"}
                        </button>
                        <button
                          onClick={ye}
                          disabled={T === F}
                          className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${T === F ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-700 bg-white hover:bg-gray-50"}`}
                        >
                          {"Next"}
                        </button>
                      </div>
                      <div
                        className={"hidden sm:flex-1 sm:flex sm:items-center sm:justify-between"}
                      >
                        <div>
                          <p className={"text-sm text-gray-700"}>
                            {"Showing"} <span className={"font-medium"}>{B + 1}</span> {"to"}{" "}
                            <span className={"font-medium"}>{Math.min(K, Y.length)}</span> {"of"}{" "}
                            <span className={"font-medium"}>{Y.length}</span> {"results"}
                          </p>
                        </div>
                        <div>
                          <nav
                            className={"relative z-0 inline-flex rounded-md shadow-sm -space-x-px"}
                            aria-label={"Pagination"}
                          >
                            <button
                              onClick={te}
                              disabled={T === 1}
                              className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${T === 1 ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                            >
                              <ChevronLeftIcon className={"h-5 w-5"} />
                            </button>
                            {Array.from(
                              {
                                length: Math.min(5, F),
                              },
                              (V, de) => {
                                const oe = de + 1;
                                return (
                                  <button
                                    key={oe}
                                    onClick={() => ve(oe)}
                                    className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${oe === T ? "z-10 bg-purple-50 border-purple-500 text-purple-600" : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"}`}
                                  >
                                    {oe}
                                  </button>
                                );
                              },
                            )}
                            <button
                              onClick={ye}
                              disabled={T === F}
                              className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${T === F ? "text-gray-400 bg-gray-100 cursor-not-allowed" : "text-gray-500 bg-white hover:bg-gray-50"}`}
                            >
                              <ChevronRightIcon className={"h-5 w-5"} />
                            </button>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </jsxRuntime.Fragment>
            ) : (
              <div className={"p-8 text-center"}>
                <div className={"flex flex-col items-center justify-center space-y-4"}>
                  <div
                    className={
                      "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center text-gray-400"
                    }
                  >
                    <TicketIcon className={"h-8 w-8"} />
                  </div>
                  <div>
                    <h3 className={"text-xl font-bold text-gray-800 mb-1"}>{"No Coupons Found"}</h3>
                    <p className={"text-gray-500"}>
                      {c || f !== "all" || p !== "all"
                        ? "No coupons match your current filters."
                        : "Create your first coupon to get started."}
                    </p>
                  </div>
                  {!c && f === "all" && p === "all" && (
                    <button
                      onClick={() => {
                        (ne(), v(true));
                      }}
                      className={
                        "mt-4 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white py-2 px-4 rounded-xl font-medium transition duration-300 flex items-center"
                      }
                    >
                      <PlusIcon className={"w-4 h-4 mr-2"} />
                      {"Create First Coupon"}
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </motion.div>
      </main>
      {y && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
          }
        >
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.95,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className={
              "bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            }
          >
            <div className={"p-6 border-b border-gray-200"}>
              <h2 className={"text-2xl font-bold text-gray-800 flex items-center"}>
                <PlusIcon className={"w-6 h-6 mr-2 text-purple-600"} />
                {"Create New Coupon"}
              </h2>
            </div>
            <form onSubmit={L} className={"p-6 space-y-6"}>
              <div className={"grid grid-cols-1 md:grid-cols-2 gap-6"}>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Coupon Code *"}
                  </label>
                  <input
                    type={"text"}
                    value={$.code}
                    onChange={(V) =>
                      I({
                        ...$,
                        code: V.target.value.toUpperCase(),
                      })
                    }
                    placeholder={"e.g., SAVE20"}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                    required={true}
                  />
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Category"}
                  </label>
                  <select
                    value={$.category}
                    onChange={(V) =>
                      I({
                        ...$,
                        category: V.target.value,
                      })
                    }
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  >
                    <option value={"both"}>{"Both (Hardware & Software)"}</option>
                    <option value={"hardware"}>{"Hardware Only"}</option>
                    <option value={"software"}>{"Software Only"}</option>
                  </select>
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Discount Type *"}
                  </label>
                  <select
                    value={$.discount_type}
                    onChange={(V) =>
                      I({
                        ...$,
                        discount_type: V.target.value,
                      })
                    }
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  >
                    <option value={"percent"}>{"Percentage"}</option>
                    <option value={"flat"}>{"Flat Amount"}</option>
                  </select>
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Discount Value *"}
                  </label>
                  <div className={"relative"}>
                    <input
                      type={"number"}
                      step={"0.01"}
                      min={"0"}
                      value={$.discount_value}
                      onChange={(V) =>
                        I({
                          ...$,
                          discount_value: V.target.value,
                        })
                      }
                      placeholder={$.discount_type === "percent" ? "20" : "100"}
                      className={
                        "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      }
                      required={true}
                    />
                    <div
                      className={
                        "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                      }
                    >
                      {$.discount_type === "percent" ? "%" : "₹"}
                    </div>
                  </div>
                </div>
                {$.discount_type === "percent" && (
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                      {"Maximum Discount (₹)"}
                    </label>
                    <input
                      type={"number"}
                      step={"0.01"}
                      min={"0"}
                      value={$.max_discount}
                      onChange={(V) =>
                        I({
                          ...$,
                          max_discount: V.target.value,
                        })
                      }
                      placeholder={"e.g., 1000"}
                      className={
                        "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      }
                    />
                  </div>
                )}
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Usage Limit"}
                  </label>
                  <input
                    type={"number"}
                    min={"0"}
                    value={$.usage_limit}
                    onChange={(V) =>
                      I({
                        ...$,
                        usage_limit: V.target.value,
                      })
                    }
                    placeholder={"0 for unlimited"}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  />
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Expiry Date"}
                  </label>
                  <input
                    type={"date"}
                    value={$.expiry_date}
                    onChange={(V) =>
                      I({
                        ...$,
                        expiry_date: V.target.value,
                      })
                    }
                    min={new Date().toISOString().split("T")[0]}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  />
                </div>
              </div>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                  {"Description"}
                </label>
                <textarea
                  value={$.description}
                  onChange={(V) =>
                    I({
                      ...$,
                      description: V.target.value,
                    })
                  }
                  placeholder={"Optional description for the coupon..."}
                  rows={"3"}
                  className={
                    "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  }
                />
              </div>
              <div className={"flex items-center"}>
                <input
                  type={"checkbox"}
                  id={"active"}
                  checked={$.active}
                  onChange={(V) =>
                    I({
                      ...$,
                      active: V.target.checked,
                    })
                  }
                  className={
                    "w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  }
                />
                <label htmlFor={"active"} className={"ml-2 text-sm font-medium text-gray-700"}>
                  {"Active (coupon is available for use)"}
                </label>
              </div>
              <div className={"flex justify-end space-x-4 pt-4 border-t border-gray-200"}>
                <button
                  type={"button"}
                  onClick={() => {
                    (v(false), ne());
                  }}
                  className={
                    "px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-medium transition duration-300"
                  }
                >
                  {"Cancel"}
                </button>
                <button
                  type={"submit"}
                  disabled={C}
                  className={
                    "px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white rounded-xl font-medium transition duration-300 flex items-center disabled:opacity-50"
                  }
                >
                  {C ? (
                    <jsxRuntime.Fragment>
                      <div
                        className={
                          "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                        }
                      />
                      {"Creating..."}
                    </jsxRuntime.Fragment>
                  ) : (
                    <jsxRuntime.Fragment>
                      <SaveIcon className={"w-4 h-4 mr-2"} />
                      {"Create Coupon"}
                    </jsxRuntime.Fragment>
                  )}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
      {j && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
          }
        >
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.95,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className={
              "bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            }
          >
            <div className={"p-6 border-b border-gray-200"}>
              <h2 className={"text-2xl font-bold text-gray-800 flex items-center"}>
                <SquarePenIcon className={"w-6 h-6 mr-2 text-purple-600"} />
                {"Edit Coupon"}
              </h2>
            </div>
            <form onSubmit={ee} className={"p-6 space-y-6"}>
              <div className={"grid grid-cols-1 md:grid-cols-2 gap-6"}>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Coupon Code *"}
                  </label>
                  <input
                    type={"text"}
                    value={$.code}
                    onChange={(V) =>
                      I({
                        ...$,
                        code: V.target.value.toUpperCase(),
                      })
                    }
                    placeholder={"e.g., SAVE20"}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                    required={true}
                  />
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Category"}
                  </label>
                  <select
                    value={$.category}
                    onChange={(V) =>
                      I({
                        ...$,
                        category: V.target.value,
                      })
                    }
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  >
                    <option value={"both"}>{"Both (Hardware & Software)"}</option>
                    <option value={"hardware"}>{"Hardware Only"}</option>
                    <option value={"software"}>{"Software Only"}</option>
                  </select>
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Discount Type *"}
                  </label>
                  <select
                    value={$.discount_type}
                    onChange={(V) =>
                      I({
                        ...$,
                        discount_type: V.target.value,
                      })
                    }
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  >
                    <option value={"percent"}>{"Percentage"}</option>
                    <option value={"flat"}>{"Flat Amount"}</option>
                  </select>
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Discount Value *"}
                  </label>
                  <div className={"relative"}>
                    <input
                      type={"number"}
                      step={"0.01"}
                      min={"0"}
                      value={$.discount_value}
                      onChange={(V) =>
                        I({
                          ...$,
                          discount_value: V.target.value,
                        })
                      }
                      placeholder={$.discount_type === "percent" ? "20" : "100"}
                      className={
                        "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      }
                      required={true}
                    />
                    <div
                      className={
                        "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                      }
                    >
                      {$.discount_type === "percent" ? "%" : "₹"}
                    </div>
                  </div>
                </div>
                {$.discount_type === "percent" && (
                  <div>
                    <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                      {"Maximum Discount (₹)"}
                    </label>
                    <input
                      type={"number"}
                      step={"0.01"}
                      min={"0"}
                      value={$.max_discount}
                      onChange={(V) =>
                        I({
                          ...$,
                          max_discount: V.target.value,
                        })
                      }
                      placeholder={"e.g., 1000"}
                      className={
                        "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      }
                    />
                  </div>
                )}
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Usage Limit"}
                  </label>
                  <input
                    type={"number"}
                    min={"0"}
                    value={$.usage_limit}
                    onChange={(V) =>
                      I({
                        ...$,
                        usage_limit: V.target.value,
                      })
                    }
                    placeholder={"0 for unlimited"}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  />
                </div>
                <div>
                  <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                    {"Expiry Date"}
                  </label>
                  <input
                    type={"date"}
                    value={$.expiry_date}
                    onChange={(V) =>
                      I({
                        ...$,
                        expiry_date: V.target.value,
                      })
                    }
                    min={new Date().toISOString().split("T")[0]}
                    className={
                      "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                    }
                  />
                </div>
              </div>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-2"}>
                  {"Description"}
                </label>
                <textarea
                  value={$.description}
                  onChange={(V) =>
                    I({
                      ...$,
                      description: V.target.value,
                    })
                  }
                  placeholder={"Optional description for the coupon..."}
                  rows={"3"}
                  className={
                    "w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  }
                />
              </div>
              <div className={"flex items-center"}>
                <input
                  type={"checkbox"}
                  id={"edit-active"}
                  checked={$.active}
                  onChange={(V) =>
                    I({
                      ...$,
                      active: V.target.checked,
                    })
                  }
                  className={
                    "w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  }
                />
                <label htmlFor={"edit-active"} className={"ml-2 text-sm font-medium text-gray-700"}>
                  {"Active (coupon is available for use)"}
                </label>
              </div>
              <div className={"flex justify-end space-x-4 pt-4 border-t border-gray-200"}>
                <button
                  type={"button"}
                  onClick={() => {
                    (N(false), _(null), ne());
                  }}
                  className={
                    "px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-medium transition duration-300"
                  }
                >
                  {"Cancel"}
                </button>
                <button
                  type={"submit"}
                  disabled={C}
                  className={
                    "px-6 py-3 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900 text-white rounded-xl font-medium transition duration-300 flex items-center disabled:opacity-50"
                  }
                >
                  {C ? (
                    <jsxRuntime.Fragment>
                      <div
                        className={
                          "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                        }
                      />
                      {"Updating..."}
                    </jsxRuntime.Fragment>
                  ) : (
                    <jsxRuntime.Fragment>
                      <SaveIcon className={"w-4 h-4 mr-2"} />
                      {"Update Coupon"}
                    </jsxRuntime.Fragment>
                  )}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
      {b && O && (
        <div
          className={
            "fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
          }
        >
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.95,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className={"bg-white rounded-2xl shadow-xl max-w-md w-full"}
          >
            <div className={"p-6"}>
              <div className={"flex items-center mb-4"}>
                <div
                  className={
                    "w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4"
                  }
                >
                  <TriangleAlertIcon className={"w-6 h-6 text-red-600"} />
                </div>
                <div>
                  <h3 className={"text-lg font-semibold text-gray-900"}>{"Delete Coupon"}</h3>
                  <p className={"text-sm text-gray-500"}>{"This action cannot be undone"}</p>
                </div>
              </div>
              <div className={"mb-6"}>
                <p className={"text-gray-600"}>
                  {"Are you sure you want to delete the coupon "}
                  <strong>
                    {'"'}
                    {O.code}
                    {'"'}
                  </strong>
                  {"? This will permanently remove the coupon and it cannot be recovered."}
                </p>
              </div>
              <div className={"flex justify-end space-x-4"}>
                <button
                  onClick={() => {
                    (S(false), _(null));
                  }}
                  className={
                    "px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition duration-300"
                  }
                >
                  {"Cancel"}
                </button>
                <button
                  onClick={re}
                  disabled={C}
                  className={
                    "px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition duration-300 flex items-center disabled:opacity-50"
                  }
                >
                  {C ? (
                    <jsxRuntime.Fragment>
                      <div
                        className={
                          "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                        }
                      />
                      {"Deleting..."}
                    </jsxRuntime.Fragment>
                  ) : (
                    <jsxRuntime.Fragment>
                      <Trash2Icon className={"w-4 h-4 mr-2"} />
                      {"Delete Coupon"}
                    </jsxRuntime.Fragment>
                  )}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};
export { CouponsPage };
